/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_DownloadInputs */

const fr_btn_download = /** @type {(inputs: Btn_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger quick-search.zip`)
};

const en_btn_download = /** @type {(inputs: Btn_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download quick-search.zip`)
};

/**
* | output |
* | --- |
* | "Download quick-search.zip" |
*
* @param {Btn_DownloadInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const btn_download = /** @type {((inputs?: Btn_DownloadInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_DownloadInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_btn_download(inputs)
	return en_btn_download(inputs)
});